<template>
  <div class="videoList">
    <div class="project-list">
      <div class="project-item" :class="{'border-right': i !== videoList.length-1 && (i+1)%3 !==0}" v-for="(v, i) in videoList" :key="i" @click="goVideo(v)">
        <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/newimg.png')">
        <div class="project-title txt-line-1 hidden-xs-only">{{v.title}}</div>
        <div class="project-title-xs txt-line-3">{{v.title}}</div>
      </div>
    </div>
    <div class="project-pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {getArticleListByColId} from '@/api/project'
import {imgError} from '@/assets/utility.js'
export default {
    name: "videoList",
    data() {
        return {
            videoList: [],
            currentPage: 1,
            pageSize: 30,
            colId: "",
            total: 0
        }
    },
    mounted() {
        this.$store.commit('setNewsTabI', 1)
        this.colId = this.$route.query.colId
        this.loadData()
    },
    methods: {
        imgError(pUrl) {
            imgError(pUrl)
        },
        loadData () {
            getArticleListByColId(this.colId,this.currentPage, this.pageSize).then(res => {
                if (res) {
                    this.videoList = res.rows
                    this.total = res.total - 0
                }
            })
        },
        goVideo (v) {
            this.$router.push(`/video/${v.id}`)
        },
        handleCurrentChange(e) {
            this.currentPage = e
            this.loadData(this.colId)
        },
    }
}
</script>
<style lang="scss" scoped>
    .project-pagination-wrap {
        margin: 20px 0;
    }
    .videoList {
      padding: 0 rem(75)
    }
</style>